import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MenuCategoriesComponent from './categories.component';

import EditCategory from './edit/edit';

const categoriesModule = angular.module('tinaba.components.menu.categories', [
  uiRouter,
  EditCategory.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('menu.categories', {
    url: '/categories',
    template: '<menu-categories></menu-categories>'
  });
})

.component('menuCategories', MenuCategoriesComponent);

export default categoriesModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/categories/categories.js
 **/